import React from 'react';
import { cn } from '../../utils/cn';

const badgeVariants = {
  default: 'bg-muted-background text-text-primary',
  primary: 'bg-primary/10 text-primary dark:bg-primary/20',
  success: 'bg-success/10 text-success dark:bg-success/20',
  warning: 'bg-warning/10 text-warning dark:bg-warning/20',
  error: 'bg-error/10 text-error dark:bg-error/20',
  info: 'bg-info/10 text-info dark:bg-info/20',
  outline: 'border border-border text-text-primary',
};

const badgeSizes = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-2.5 py-1 text-xs',
  lg: 'px-3 py-1.5 text-sm',
};

export const Badge = ({ children, variant = 'default', size = 'md', className, ...props }) => {
  return (
    <span
      className={cn(
        'transition-theme inline-flex items-center rounded-full font-medium',
        badgeVariants[variant],
        badgeSizes[size],
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
};
